module.exports = __webpack_public_path__ + "img/erlenmeyer.c03e625a.svg";